import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import React, { ReactNode } from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { Footer } from 'src/components/Footer/Footer';
import Header from 'src/components/Header/Header';
import NavBar from 'src/components/Navigation/NavBar';
import SignupNavBar from 'src/components/Navigation/SignupNavBar';
import { getConfig } from 'src/utilities/config';

export interface ILayoutProps {
  children: ReactNode;
  isSignupFlow?: boolean;
  title: string;
}

export default function Layout({
  children,
  isSignupFlow,
  title,
}: ILayoutProps): JSX.Element {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();
  const {
    site: { standardTitle },
  } = getConfig();

  return (
    <>
      <Helmet defer={false}>
        <title>{`${standardTitle} | ${title}`}</title>
      </Helmet>
      <Header />

      {isSignupFlow ? <SignupNavBar isErrorPage /> : <NavBar />}

      <main role="main">
        <Square
          bg="backgroundTint"
          className={classnames('layout_content', {
            layout_contentTopOffset: !isInternalAdminUser,
            layout_contentTopOffsetAdmin: isInternalAdminUser,
          })}
        >
          {children}
        </Square>
      </main>

      {!isSignupFlow && <Footer />}
    </>
  );
}
